<app-loader *ngIf="loading"></app-loader>

<div class="header">
  <span *ngIf="!data.toClone">{{ "PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.TITLE" | translate }}</span>
  <span *ngIf="data.toClone">{{ "PAGES.PRODUCTS.TRAYS.UPDATE_TRAY_DIALOG.TITLE_CLONING" | translate:{code:data.oldCode}
    }}</span>
  <span (click)="closeDialog()" class="material-icons side-nav-bar-close">clear</span>
</div>
<div class="body">
  <app-tray-form [tray]="this.data.tray" [isExtraTray]="data.isExtraTrayAllocation" [cloning]="data.toClone"
    (closeSidenav)="handleClose($event)"></app-tray-form>
</div>
